<template>
  <el-drawer
    title="需求详情"
    append-to-body
    :close-on-press-escape="false"
    :visible.sync="show"
    size="40%"
    direction="rtl">
    <div class="detail-drawer-wrap">
      <el-form label-width="90px">
        <el-form-item label="服务名称：">{{ ruleForm.servName }}</el-form-item>

        <el-divider>机构信息</el-divider>

        <el-form-item label="机构名称：">{{ ruleForm.servOrgName }}</el-form-item>
        <el-form-item label="联系人员：">{{ ruleForm.staffName }}</el-form-item>
        <el-form-item label="联系方式：">{{ ruleForm.staffMobile }}</el-form-item>

        <el-divider>企业信息</el-divider>

        <el-form-item label="企业名称：">{{ ruleForm.vendorName }}</el-form-item>
        <el-form-item label="联系人员：">{{ ruleForm.contactMan }}</el-form-item>
        <el-form-item label="联系方式：">{{ ruleForm.contactPhone }}</el-form-item>

        <el-divider>需求信息</el-divider>

        <el-form-item label="需求状态：">
          <!-- {{ ruleForm.status | ConsultStatusName() }} -->
          <el-steps
            v-if="ruleForm.status === 9"
            direction="vertical"
            :active="2"
            finish-status="success">
            <el-step title="待受理">
              <div
                slot="description"
                class="description">
                <div>时间：{{ ruleForm.createdTime | dateformat() }}</div>
                <div class="description-info">描述：{{ ruleForm.consultContent }}</div>
              </div>
            </el-step>
            <el-step title="已拒绝">
              <div
                slot="description"
                class="description">
                <div>时间：{{ ruleForm.ackTime | dateformat() }}</div>
                <div class="description-info">反馈：{{ ruleForm.ackContent || '-' }}</div>
              </div>
            </el-step>
          </el-steps>
          <el-steps
            v-else
            direction="vertical"
            :active="ruleForm.status + 1"
            finish-status="success">
            <el-step title="待受理">
              <div
                slot="description"
                class="description">
                <div>时间：{{ ruleForm.createdTime | dateformat() }}</div>
                <div class="description-info">描述：{{ ruleForm.consultContent }}</div>
              </div>
            </el-step>
            <el-step title="已受理">
              <div
                slot="description"
                class="description">
                <div>时间：{{ ruleForm.startAcceptTime | dateformat() }}</div>
              </div>
            </el-step>
            <el-step title="处理完成">
              <div
                slot="description"
                class="description">
                <div>时间：{{ ruleForm.ackTime | dateformat() }}</div>
                <div class="description-info">反馈：{{ ruleForm.ackContent || '-' }}</div>
              </div>
            </el-step>
          </el-steps>
        </el-form-item>
        <!-- <el-form-item label="需求描述：">{{ ruleForm.consultContent }}</el-form-item>
        <el-form-item label="处理结果：">{{ ruleForm.ackContent }}</el-form-item> -->
      </el-form>
    </div>
  </el-drawer>
</template>

<script>
export default {
  name: 'DetailDrawer',
  data() {
    return {
      show: false,
      loading: false,
      config: { id: null },
      ruleForm: {}
    }
  },
  methods: {
    fetchInfo() {
      this.loading = true
      this.$$OrgService.getservconsult({ ...this.config })
        .then(res => {
          this.loading = false
          const { result, message } = res.data
          if (result === 0) {
            this.$set(this, 'ruleForm', res.data)
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
      // this.$store.dispatch('business/getservconsult', {
      //   payload: this.config,
      //   success: (res) => {
      //     this.loading = false
      //     this.$set(this, 'ruleForm', res.data)
      //   },
      //   fail: () => {
      //     this.loading = false
      //   }
      // })
    },
    fetch(options) {
      this.config = { ...this.config, ...options }
      this.show = true
      this.fetchInfo()
    }
  }
}
</script>
<style lang="stylus" scoped>
  .description {
    padding 0 0 10px

    .description-info {
      // font-size 13px
      color #555
    }
  }
</style>
